import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import EmployeeReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/employee.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(EmployeeReducer, defaultState, asyncActions);
};

type IEmployeeContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const EmployeeContext = createContext<Partial<IEmployeeContext>>({
  state: defaultState,
}) as React.Context<IEmployeeContext>;

const EmployeeProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <EmployeeContext.Provider
      value={{
        ...reducer,
      }}
    >
      {children}
    </EmployeeContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useEmployeeContext = () => useContext(EmployeeContext);

export type IUseEmployeeContext = ReturnType<typeof useEmployeeContext>;

export { EmployeeContext, EmployeeProvider };
